import React, {useEffect, useState} from 'react'
import {parse} from 'date-fns'
import IconStarFull from "@Icons/IconStarFull";
import ColorGradedNode from "@Features/ratings/components/ColorGradedNode";
import formatDate from "@DateTime/functions/formatDate";
import Translation from "@Translation/components/Translation";
import {useComponentDidMount} from "@Hooks/lifecycle/useComponentDidMount";
import CompanyReviewType from "@Pages/companyProfile/types/CompanyReview.type";
import ReadMoreButton from "@Pages/companyProfile/components/ReadMoreButton";
import {Colors} from "@Styles/Colors.style";

interface CompanyReviewSnippetProps {
    readMoreExpanded: boolean,
    setReadMoreExpanded: (value: boolean) => void,
    companyReview: CompanyReviewType,
}

function CompanyReviewSnippet({readMoreExpanded, setReadMoreExpanded, companyReview}: CompanyReviewSnippetProps) {
    const {
        title,
        name,
        dateTime,
        text,
        rating,
        stationToStationUrl,
        departureStationName,
        destinationStationName,
    } = companyReview

    const [reviewText, setReviewText] = useState(`${text?.slice(0, 75)}...`)
    const [reviewTitle, setReviewTitle] = useState(`${title?.slice(0, 27)}...`)

    const readMore = () => {
        setReadMoreExpanded(!readMoreExpanded)
        setReviewTitle(title)
        setReviewText(text)
    }

    const isMount = useComponentDidMount()
    useEffect(() => {
        if (!isMount) {
            setReviewTitle(title)
            setReviewText(text)
        }
    }, [isMount, readMoreExpanded, text, title])

    const dateLabel = dateTime ? formatDate(parse(dateTime, 'yyyy-MM-dd HH:mm:ss', new Date()), 'MMMM dd, yyyy') : ''

    return (
        <div
            className="gb--card gb--review-snippet"
            style={{borderLeft: `4px solid ${Colors.secondaryColor}`}}
        >
            {reviewTitle.length && (
                <div className="gb--review-title gb--emphasize gb--emphasize-default">
                    {reviewTitle}
                </div>
            )}
            <span className="gb--review-user">
                <Translation translationKey="c_profile.by" styleText="upperCase"/>
                &nbsp;
                {name}
                {` | `}
                {dateLabel}
            </span>
            <div className="gb--review-text">
                {reviewText}
                &nbsp;
                {(title.length > 27 || text.length > 75) && !readMoreExpanded && (
                    <ReadMoreButton readMore={readMore}/>
                )}
            </div>
            <div className="gb--review__route-rating">
                {rating && (
                    <ColorGradedNode rating={rating}>
                        <IconStarFull/>
                        {rating}
                    </ColorGradedNode>
                )}
                <a href={stationToStationUrl}>
                    {departureStationName}
                    {` - `}
                    {destinationStationName}
                </a>
            </div>
        </div>
    )
}

export default CompanyReviewSnippet